import { useContext, useMemo } from 'react';
import AppContext from '../../AppContext';
import { Connection } from '@arelia-types/connection';

export default function useRequiredConnections(
  requiredConnectionNames?: string[]
): boolean {
  const { connections } = useContext(AppContext);

  return useMemo(() => {
    if (requiredConnectionNames?.length)
      return connections?.some(x => requiredConnectionNames.includes(x.name) && x.connected) ?? false;

    return true;
  }, [connections, requiredConnectionNames]);
}

export function useAllRequiredConnections (
  requiredConnectionNames?: string[]
): Connection[] {
  const { connections } = useContext(AppContext);

  return useMemo(() => {
    if (requiredConnectionNames?.length)
      return connections?.filter(x => requiredConnectionNames.includes(x.name) && x.connected) ?? [];

    return connections;
  }, [connections, requiredConnectionNames]);
}